import ContextMenuItemController from 'contextmenu/base.controller';
import ndViews from '@pressreader/src/nd.viewer.views';
import ndUser from 'nd.user';
import ndAuthentication from 'authentication/nd.authentication';
import { getBasePath } from '@pressreader/routing';
import { getConfigValue } from '@pressreader/config';
import ndTranslation from '@pressreader/src/nd.utils.translation';
import ndUiUtils from '@pressreader/src/nd.ui.utils';
import navigation from '@pressreader/src/nd.navigationhistory';

class SignOutMenuItemController extends ContextMenuItemController {
    item() {
        return this._getItem('signout', 'Viewer.SignOut', 'pri pri-logout');
    }

    available() {
        return Promise.resolve(true);
    }

    enabled() {
        return Promise.resolve(true);
    }

    async activate() {
        this._parent.hide();
        const result = await ndAuthentication.signOut();
        if (result) {
            ndTranslation.enableOriginalLanguage();
            ndUiUtils.toolbarSetup($('#toolbarTop'));
        }
    }
}

export default SignOutMenuItemController;
